/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Catalog_Scope_IssuesInputs */

const en_task_catalog_scope_issues = /** @type {(inputs: Task_Catalog_Scope_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This change conflicts with how activities are configured.`)
};

const pt_br2_task_catalog_scope_issues = /** @type {(inputs: Task_Catalog_Scope_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta alteração conflita com a configuração das atividades.`)
};

/**
* | output |
* | --- |
* | "This change conflicts with how activities are configured." |
*
* @param {Task_Catalog_Scope_IssuesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_scope_issues = /** @type {((inputs?: Task_Catalog_Scope_IssuesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Scope_IssuesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_scope_issues(inputs)
	return pt_br2_task_catalog_scope_issues(inputs)
});